const dismissedKey = (userId: number, projectId: number) =>
  `agent:project-chat-dismissed:${userId}:${projectId}`;

/** After the user deletes a project-titled agent chat, do not auto-recreate a listed one on refresh. */
export function markAgentProjectChatDismissed(userId: number, projectId: number): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(dismissedKey(userId, projectId), '1');
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAgentProjectChatDismissed(userId: number, projectId: number): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(dismissedKey(userId, projectId));
  } catch {
    /* ignore */
  }
}

export function isAgentProjectChatDismissed(userId: number, projectId: number): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return localStorage.getItem(dismissedKey(userId, projectId)) === '1';
  } catch {
    return false;
  }
}
